import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Check } from 'lucide-react';

const PaymentSuccessPage = () => {
  const { refreshProfile } = useAuth();

  useEffect(() => {
    refreshProfile();
  }, [refreshProfile]);

  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
        <Check className="h-8 w-8 text-green-600" />
      </div>
      <h1 className="font-heading font-bold text-2xl text-slate-900 mb-2">Payment successful</h1>
      <p className="text-slate-600 mb-8">
        Your membership is active. You can now browse and message verified friends. If you don&apos;t see it yet, the update may take a moment.
      </p>
      <Link
        to="/dashboard"
        className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-primary text-white font-semibold hover:bg-primary-dark"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default PaymentSuccessPage;
